import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { type FormFieldComponentProps } from "@/lib/types/types";

interface PassedProps {
  explanation?: string | JSX.Element;
}

export const DriverLicenseNumberComponent = ({
  value,
  isErrored,
  onChange,
  explanation,
  placeholder = "",
  isRequired = false,
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  const getDefaultExplanation = () =>
    !isRequired ? <FormattedHTMLMessage id="optional" defaultMessage="Optional" /> : "";

  const isFieldHidden = getFieldConfigByFieldId("driverLicenseNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="driver-license-number"
      refId="driverLicenseNumber"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "driverLicenseNumberPlaceholder" })}
      label={
        <FormattedHTMLMessage id="driverLicenseNumber" defaultMessage="Driver license number" />
      }
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidDriverLicenseNumber"
            defaultMessage="Invalid driver license number"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={isRequired}
      explanation={explanation || getDefaultExplanation()}
      disabled={disabled}
    />
  );
};
